enum MmcNotificationRouteType {
  COMPANY = "company route",
  PERSON = "people route",
}

export default MmcNotificationRouteType;
